// Recover the feed independently of chart history. An OPEN socket can be silent
// after sleep/network changes, so readyState alone does not establish health.
export function watchPlatformRecovery({ win, doc, enabled, restart, resubscribe, now = Date.now, staleMs = 20000 }) {
  let lastMessage = now(), lastAttempt = 0, opened = false, disconnected = false, disposed = false;
  let retry, poll, attempting = false;
  const usable = () => enabled() && win.navigator.onLine !== false && doc.visibilityState !== 'hidden';
  const repair = async () => {
    if (disposed || attempting || !usable() || (!disconnected && now() - lastMessage < staleMs)) return;
    if (lastAttempt && now() - lastAttempt < 5000) return;
    attempting = true; lastAttempt = now();
    try { await restart(); } catch { /* The poll retries while the account remains active. */ }
    finally { attempting = false; }
  };
  const close = () => {
    disconnected = true;
    win.clearTimeout(retry);
    retry = win.setTimeout(repair, 250);
  };
  const open = () => { opened = true; disconnected = false; lastMessage = now(); lastAttempt = 0; };
  const message = () => { lastMessage = now(); };
  const resume = () => {
    if (!usable()) return;
    if (disconnected || (opened && now() - lastMessage >= staleMs)) repair();
    else if (opened && now() - lastMessage >= 5000) resubscribe();
  };
  const tick = () => { if (opened || disconnected) repair(); poll = win.setTimeout(tick, 5000); };
  doc.addEventListener('connectionClosed', close);
  doc.addEventListener('connectionOpened', open);
  doc.addEventListener('ws_message_platform', message);
  doc.addEventListener('visibilitychange', resume);
  win.addEventListener('online', resume);
  win.addEventListener('pageshow', resume);
  poll = win.setTimeout(tick, 5000);
  return () => {
    disposed = true; win.clearTimeout(poll); win.clearTimeout(retry);
    doc.removeEventListener('connectionClosed', close);
    doc.removeEventListener('connectionOpened', open);
    doc.removeEventListener('ws_message_platform', message);
    doc.removeEventListener('visibilitychange', resume);
    win.removeEventListener('online', resume); win.removeEventListener('pageshow', resume);
  };
}
